import { legacy } from '@/shared/api/client';
import type { MetabaseConfig } from '@/shared/types';

/** Persiste a lista de dashboards do Metabase no passbook (PUT /passbook/:id/metabase). */
export async function updateMetabaseConfig(
  idPassbook: string,
  metabase: MetabaseConfig[],
): Promise<void> {
  await legacy.put<{ ok: boolean }>(
    `/passbook/${idPassbook}/metabase`,
    { metabase },
    { headers: { 'X-Passbook-Id': idPassbook } },
  );
}
